import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

export class HistoryRequestController {
    async historyCloseOpen(
        depsId: number[] | null,
        kassaId: number | null,
        startDate: Date | null,
        toDate: Date | null,
    ) {
        return server.post(
            `/CashierReport/getCashierActions`,
            {
                depIds: depsId,
                kassaId,
                startDate,
                toDate
            },
            {
                baseURL: BACKEND_URL,
            }
        );
    }

    async historyCashList(
        depsIds: number[] | null,
        kassaId: number | null,
        startDate: Date | null,
        toDate: Date | null,
    ) {
        return server.post(
            `/CashierReport/getCashActions`,
            {
                depIds: depsIds,
                kassaId,
                startDate,
                toDate
            },
            {
                baseURL: BACKEND_URL,
            }
        );
    }
}
